import { createRouter, createWebHashHistory } from "vue-router";
import { memoryStorage } from "@/utils/memoryStorage";
// 动态导入组件
const Home = () => import("@/views/Home.vue");
const Compound = () => import("@/views/BrowseCompound.vue");
const CompoundDetail = () => import("@/views/DetailCompound.vue");
const Download = ()=>import("@/views/Download.vue")
const About = () => import("@/views/About.vue");
const Help = () => import("@/views/Help.vue");
const Search =()=>import("@/views/Search.vue")

// 路由规则
const routes = [
  { path: "/", redirect: "/home" }, // 重定向到首页
  { path: "/home", name: "home", component: Home },
  { path: "/compound", name: "compound", component: Compound },
  { path: "/detail", name: "compound-detail", component: CompoundDetail },
  { path: "/download", name: "download", component: Download },
  { path: "/about", name: "about", component: About },
  { path: "/help", name: "help", component: Help },
 {
    path: "/search",
    name: "search",
    component: Search,
    beforeEnter: (to, from, next) => {
        // 【修改】：使用 memoryStorage 替代 sessionStorage
        const searchResults = memoryStorage.getItem("searchResults");
        if (!searchResults) {
            // 如果没有搜索结果，重定向到首页并显示提示
            next({ name: "home" });
        } else {
            next(); // 如果有搜索结果，允许进入
        }
    }
},

];

// 创建并导出路由器
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.name === 'search' && !memoryStorage.getItem('searchResults')) {
    // 如果用户直接访问 /search，但内存没有结果，就跳首页
    return next({ name: 'home' })
  }
  next()
})

export default router;
